
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Puneairportpickupanddrop() {



  const cardData =
  {
    keyword: ' Pune Airport Pickup and Drop',
    heading: 'SHREE Tours & Travels: Pune Airport Pickup and Drop',
    headingDescription: 'SHREE Tours & Travels offers Pune Airport pickup and drop service, ensuring a smooth, reliable and hassle-free travel experience for business travelers, families and tourists. Whether you need a pickup from Pune Airport to your destination or a drop-off from your location to Pune Airport, our well-maintained fleet provides timely and comfortable rides. With professional chauffeurs, affordable pricing and 24/7 availability, we guarantee a seamless airport transfer. Choose SHREE Tours & Travels for the best Pune Airport pickup and drop service.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historic fortification in Pune that served as the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand palace complex is known for its massive entrance gates, intricate wooden architecture and fascinating history of power struggles. The fort also has a haunted reputation, making it an intriguing site for history lovers and adventure seekers alike. The evening light and sound show narrates the glorious past of the Marathas, adding to the immersive experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace is a majestic historical landmark known for its architectural beauty and significance in India’s freedom struggle. Built in 1892 by Sultan Aga Khan III, the palace served as a prison for Mahatma Gandhi, Kasturba Gandhi and other freedom fighters during the Quit India Movement. The palace features well-maintained gardens, a museum displaying rare photographs and artifacts that provide insight into India’s fight for independence."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop the Sahyadri hills, Sinhagad Fort is one of Pune’s most famous trekking destinations and historical sites. The fort played a crucial role in several battles, including the legendary Battle of Sinhagad in 1670, where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. The fort offers breathtaking views, trekking trails and local Maharashtrian snacks like ‘Kanda Bhaji’ and ‘Pithla Bhakri,’ making it a must-visit for adventure and history enthusiasts."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Dagdusheth Halwai Ganpati Temple is one of the most revered Ganesh temples in Maharashtra, known for its magnificent idol adorned with gold and precious ornaments. Devotees from across the country visit this temple to seek blessings, especially during the Ganesh Chaturthi festival when grand celebrations take place. The temple’s spiritual ambiance and architectural beauty make it a significant religious landmark in Pune."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "The Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved out of a single rock in the 8th century. The temple, located in the heart of Pune, features beautifully sculpted pillars, a Nandi bull statue and a serene ambiance perfect for meditation. This hidden gem offers a glimpse into the city's rich historical and architectural heritage."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Raja Dinkar Kelkar Museum houses an incredible collection of over 20,000 artifacts, including ancient musical instruments, paintings, sculptures and everyday household items from different eras of Indian history. Founded by Dr. Dinkar Kelkar, the museum offers a fascinating journey through time, making it a must-visit for history and art enthusiasts."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a serene getaway for nature lovers and bird watchers in Pune. The lake is home to various migratory birds, making it a popular destination for photography and peaceful walks. With its calm waters and lush greenery, it provides a refreshing escape from the city's hustle and bustle."
    },
    {
        "title": "Osho International Meditation Resort",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-famous spiritual retreat offering meditation sessions, wellness programs and holistic healing therapies. The resort is set amidst lush gardens, tranquil water bodies and modern Zen architecture, providing a perfect space for relaxation and self-discovery."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic spot offering scenic views, cool breezes and a tranquil environment. The nearby Sinhagad Fort and Peacock Bay add to its charm, making it an ideal destination for weekend outings and photography."
    },
    {
        "title": "Okayama Friendship Garden",
        "description": "Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully designed Japanese-style garden in Pune. Inspired by the Korakuen Garden in Okayama, Japan, this park features scenic landscapes, flowing streams and well-maintained walking paths, making it a peaceful retreat for visitors looking to unwind in a natural setting."
    }
],  
    
            
"services": [
    {
      "name": "Pune Airport Taxi Service",
      "description": "Book a convenient and reliable Pune Airport Taxi service with SHREE Tours & Travels. Our fleet of well-maintained cars and professional drivers ensures timely and comfortable travel to and from Pune Airport."
    },
    {
      "name": "Pune Airport Pickup and Drop Booking",
      "description": "Looking for a hassle-free pickup and drop service at Pune Airport? SHREE Tours & Travels offers seamless booking options for both Pune Airport pickups and drops with experienced drivers and affordable pricing."
    },
    {
      "name": "Book Pune Airport Cab",
      "description": "Booking a Cab from Pune Airport has never been easier. Simply choose from our range of Cabs, including sedans, SUVs and luxury cars and enjoy a comfortable ride to your destination in Pune."
    },
    {
      "name": "Affordable Pune Airport Transfer",
      "description": "Travel to or from Pune Airport affordably with our budget-friendly airport transfer services. Get the best rates without compromising on comfort or quality."
    },
    {
      "name": "Luxury Pune Airport Taxi",
      "description": "For a premium travel experience, book our luxury Pune Airport taxi service. Enjoy a comfortable ride in high-end vehicles like the Mercedes, Innova Crysta, or other luxury options, along with professional drivers."
    },
    {
      "name": "One-Way Airport Drop from Pune",
      "description": "Need a one-way drop to Pune Airport? Our one-way taxi service ensures a smooth, timely and comfortable ride from your location in Pune to the airport."
    },
    {
      "name": "Pune Airport Transfer Cab Service",
      "description": "Book a reliable Pune Airport transfer Cab service with SHREE Tours & Travels. We ensure timely pickups and drops to make your airport travel smooth and stress-free."
    },
    {
      "name": "Pune Airport Pickup Service",
      "description": "We offer prompt and reliable Pune Airport pickup services. Our experienced drivers will greet you at the airport and take you to your destination safely and comfortably."
    },
    {
      "name": "Private Taxi for Pune Airport Travel",
      "description": "For personalized and private travel, book a private taxi for Pune Airport. Enjoy the comfort and convenience of a dedicated vehicle that will pick you up and drop you off directly at the airport."
    },
    {
      "name": "Group Airport Pickup from Pune",
      "description": "Traveling with a group? Book a spacious vehicle for group airport pickups from Pune. Our well-maintained cars ensure a comfortable ride for everyone."
    },
    {
      "name": "Pune to Airport Cab Service",
      "description": "Need a ride to Pune Airport? Our Pune to Airport Cab service ensures timely and safe transport to the airport. Choose from a range of vehicles to suit your needs."
    },
    {
      "name": "Pune Airport to Hotel Cab",
      "description": "Arriving at Pune Airport? Book a convenient Pune Airport to hotel Cab service with SHREE Tours & Travels. Our reliable drivers will take you directly to your hotel from the airport, ensuring a smooth transition."
    },
    {
      "name": "Pune Airport to City Transfer",
      "description": "Book a Pune Airport to City Transfer with us. Whether you are heading to a business meeting or sightseeing, our airport transfer service ensures a comfortable and timely ride to your destination in Pune."
    },
    {
      "name": "Pune Airport to Railway Station Cab",
      "description": "Need to catch a train after your flight? Our Pune Airport to Railway Station Cab service provides comfortable, timely and safe transport from the airport to the nearest railway station."
    },
    {
      "name": "Pune Airport Drop Service",
      "description": "Enjoy a hassle-free drop to Pune Airport with our dedicated drop service. Our experienced drivers ensure timely arrivals, making sure you never miss your flight."
    },
    {
      "name": "Pune Airport Cab Hire",
      "description": "Hire a Cab for your Pune Airport travel needs. Whether it's a quick drop-off or a pick-up, our Pune Airport Cab Hire service ensures convenience and comfort at affordable rates."
    }
  ],

  "tableData": [
    ["- Pune Airport Taxi Service", "- Pune Airport Pickup and Drop Booking"],
    ["- Book Pune Airport Cab", "- Affordable Pune Airport Transfer"],
    ["- Luxury Pune Airport Taxi", "- One-Way Airport Drop from Pune"],
    ["- Pune Airport Transfer Cab Service", "- Pune Airport Pickup Service"],
    ["- Private Taxi for Pune Airport Travel", "- Group Airport Pickup from Pune"],
    ["- Pune to Airport Cab Service", "- Pune Airport to Hotel Cab"],
    ["- Pune Airport to City Transfer", "- Pune Airport to Railway Station Cab"],
    ["- Pune Airport Drop Service", "- Pune Airport Cab Hire"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Reliable and Timely Service",
      "WhyChoosedescription": "Our Pune Airport pickup and drop services are designed to provide you with reliable and timely transportation. Whether you're arriving or departing, our drivers will ensure that you're picked up or dropped off on time, allowing you to relax and focus on your travel without any stress."
    },
    {
      "WhyChooseheading": "Comfortable Ride",
      "WhyChoosedescription": "We ensure a comfortable journey with our well-maintained vehicles equipped with spacious seating and air-conditioning. Whether you’re heading to the airport or returning from a flight, our vehicles provide a relaxing and comfortable ride, allowing you to travel with ease."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our experienced drivers are knowledgeable about Pune Airport and the best routes to take for your pickup and drop. They focus on punctuality and safety, ensuring you reach your destination in a timely and comfortable manner, without any hassle."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer affordable and transparent pricing for your Pune Airport pickup and drop. There are no hidden fees and we provide great value for the convenience and comfort of our service. Whether you're booking a one-way trip or a round trip, we offer budget-friendly rates to suit your needs."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "Our vehicles are regularly serviced and maintained to ensure your safety and comfort. We ensure that our fleet is clean, reliable and fully equipped to provide you with a smooth ride. From mechanical checks to cleanliness, we take great care to offer the best service possible."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking your Pune Airport pickup and drop service with us is easy and quick. You can book through our user-friendly online platform or contact our customer service team for assistance. Whether it's a last-minute need or an advanced booking, we make the process simple and hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Pune Airport pickup and drop needs. Whether you're arriving on a late-night flight or need an early-morning ride, we’re always available to accommodate your schedule. Our round-the-clock service ensures that we are here to meet your travel needs anytime."
    },
    {
      "WhyChooseheading": "Hassle-Free Experience",
      "WhyChoosedescription": "Our Pune Airport pickup and drop services are designed to make your travel experience as smooth as possible. From easy booking to timely pickups and drop-offs, we handle all the details so you can travel stress-free. You can trust us to make your airport transfers convenient and hassle-free."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we focus on customer satisfaction and aim to provide the best possible service. Our team ensures that your Pune Airport pickup and drop experience is smooth, punctual and pleasant. With our commitment to quality, we guarantee a hassle-free airport transfer every time."
    }
  ]
  
  
  
  
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Pune Airport pickup or drop?",
        answer: "You can easily book your Pune Airport pickup or drop service through our website or by calling our customer service for assistance."
    },
    {
        question: "Do you offer both pickup and drop services at Pune Airport?",
        answer: "Yes, we provide both pickup and drop services for Pune Airport, making your travel to and from the airport hassle-free."
    },
    {
        question: "What types of vehicles are available for Pune Airport pickup and drop?",
        answer: "We offer a variety of vehicles for Pune Airport pickup and drop, including sedans, SUVs and MPVs, depending on your group size and preference."
    },
    {
        question: "Are the rates for Pune Airport pickup and drop inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided at the time of booking."
    },
    {
        question: "Do you provide drivers for the Pune Airport pickup and drop?",
        answer: "Yes, all our vehicles come with experienced drivers who will ensure a smooth and timely pickup or drop-off at Pune Airport."
    },
    {
        question: "What is the cancellation policy for Pune Airport pickup and drop bookings?",
        answer: "We offer a flexible cancellation policy. Please contact us for specific details regarding your booking."
    },
    {
        question: "What payment methods do you accept for Pune Airport pickup and drop services?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for Pune Airport pickup and drop?",
        answer: "Yes, all our vehicles come with insurance coverage to ensure your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Pune Airport pickup or drop?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "How do I contact you for Pune Airport pickup and drop bookings?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'SHREE Tours & Travels made my airport pickup smooth and easy. The driver was on time and the vehicle was clean and comfortable.',
        name: 'Mr. Ashish Mehta',
    },
    {
        text: 'I had a pleasant experience with their Pune Airport drop service. The driver was friendly and I reached the airport on time without any hassle.',
        name: 'Miss. Shruti Soni',
    }
];








  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Pune airport pickup and drop service with SHREE Tours & Travels. Enjoy affordable fares for your airport transfer needs. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/pune-airport-pickup-drop.jpg",
    "https://shreetoursandtravels.in/img/pune-airport-transfer-cab.jpg"
  ],
  "priceRange": "₹500 - ₹2000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/pune-airport-pickup-drop-service",
    "priceCurrency": "INR",
    "price": 1000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.9,
    "reviewCount": 1500
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Priya Deshmukh"
      },
      "datePublished": "2024-11-05",
      "reviewBody": "Very reliable service for airport transfers. The Cab was on time and the driver was courteous. Highly recommended for Pune airport travel!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Vikram Jadhav"
      },
      "datePublished": "2024-12-01",
      "reviewBody": "I booked a drop service from Pune airport to my hotel and the experience was seamless. The car was clean and the driver was professional."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Pune Airport Pickup and Drop Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5812,  // Pune airport latitude
      "longitude": 73.9147  // Pune airport longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/pune-airport-pickup-drop-service"
  },
  "keywords": "Pune Airport Taxi Service, Pune Airport Pickup and Drop Booking, Book Pune Airport Cab, Affordable Pune Airport Transfer, Luxury Pune Airport Taxi, One-Way Airport Drop from Pune, Pune Airport Transfer Cab Service, Pune Airport Pickup Service, Private Taxi for Pune Airport Travel, Group Airport Pickup from Pune, Pune to Airport Cab Service, Pune Airport to Hotel Cab, Pune Airport to City Transfer, Pune Airport to Railway Station Cab, Pune Airport Drop Service, Pune Airport Cab Hire"
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune Airport Pickup and Drop Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Pune airport pickup and drop service with SHREE Tours & Travels. Enjoy affordable fares for your airport transfer needs. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune Airport Taxi Service, Pune Airport Pickup and Drop Booking, Book Pune Airport Cab, Affordable Pune Airport Transfer, Luxury Pune Airport Taxi, One-Way Airport Drop from Pune, Pune Airport Transfer Cab Service, Pune Airport Pickup Service, Private Taxi for Pune Airport Travel, Group Airport Pickup from Pune, Pune to Airport Cab Service, Pune Airport to Hotel Cab, Pune Airport to City Transfer, Pune Airport to Railway Station Cab, Pune Airport Drop Service, Pune Airport Cab Hire" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/8.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Puneairportpickupanddrop;